import AttendanceScannerModal from "./attendance-scanner-modal";


const AttendanceModals = {
    Scanner: AttendanceScannerModal
};

export {
    AttendanceScannerModal
};

export default AttendanceModals;
